module.exports = __webpack_public_path__ + "img/self5.97bae9ce.gif";